<template>
  <m-card921 :image="content.thumbnail" :alt="content.title">

    <m-a :href="{name:'SinglePost',params:{slug:content.slug}}">
      <m-h5 class="text-white post-card-921">{{ contentSlicer(content.title,25) }}</m-h5>
    </m-a>


  </m-card921>
</template>

<script>
import mCard921 from '../../Cards/Card921.vue'
import mIcon from "../../Icons/Icon.vue";
import mA from "../../Tags/A.vue";
import mH5 from "../../Tags/H5.vue";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "PostCard921",
  methods: {contentSlicer},
  props: {
    content: {}
  },
  components: {mH5, mA, mIcon, mCard921},

}
</script>

<style scoped>
.post-card-921{
  font-size: 18px;
}
</style>